import { render, staticRenderFns } from "./SkeletonHome.vue?vue&type=template&id=2271b2ce&scoped=true&"
var script = {}
import style0 from "./SkeletonHome.vue?vue&type=style&index=0&id=2271b2ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2271b2ce",
  null
  
)

export default component.exports